// Clinic Configuration for Dentist in Perrysburg
// This file contains all clinic-specific values used across the application

export const CLINIC_CONFIG = {
  // Basic Information
  clinicName: "Dentist in Perrysburg",
  clinicId: "dentistinperrysburg",
  clinicUrl: "https://dentistinperrysburg.com",
  // Contact Information
  phoneNumber: "(419) 792-1264",
  phoneNumberRaw: "+14197921264", // For tel: and sms: links
  email: "DentalCare@DentistinPerrysburg.com",
  aiAgent: "wss://ws.todaysdentalinsights.com/ai-agents?clinicId=dentistinperrysburg&agentId=38c8507c-5674-47e4-9255-a0cf166b1928",
  voiceApiUrl: "https://apig.todaysdentalinsights.com/ai-agents/public/clinic/dentistinperrysburg/voice",

  // Location
  address: "110 E South Boundary St, Perrysburg, OH 43551, United States",
  addressShort: "110 E South Boundary St, Perrysburg, OH 43551",
  city: "Perrysburg",
  hcity: "Perrysburg",
  state: "Ohio",
  stateShortForm: "OH",
  PostalCode: "43551",
  // Map Links
  mapUrl: "https://maps.app.goo.gl/XWbgxCbJ7vpngCWc6",

  // Embedded Map
  iframe: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2702.262595851859!2d-83.619503!3d41.54548889999999!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x883c77cfe1cc7de3%3A0x5c90392fe313343b!2sDentist%20in%20Perrysburg!5e1!3m2!1sen!2sin!4v1759819794846!5m2!1sen!2sin',
  iframeTitle: "Dentist in Perrysburg",

  //membership
  membership: "https://member.kleer.com/?slug=NX3Y",

  // Sunbit
  sunbitUrl: "https://apply.sunbit.com/DentistInPerrysburg",

  // Cherry
  cherryUrl: "https://pay.withcherry.com/dentist-in-perrysburg?utm_source=practice&utm_medium=email&m=65970",


  // Analytics
  gaMeasurementId: "G-BKFW9WYLDG",
  clarityProjectId: "prcxhz2cnj",

  // API Configuration
  apiBaseUrl: "https://apig.todaysdentalinsights.com/patientportal/dentistinperrysburg",
  callbackUrl: "https://apig.todaysdentalinsights.com/callback/dentistinperrysburg",
  clinicHoursUrl: "https://apig.todaysdentalinsights.com/clinic-hours/hours/dentistinperrysburg",
  websocketUrl: "wss://ws.todaysdentalinsights.com/chat",
  webAssistantUrl: "https://dentistinperrysburg.web-assistant.tensorlinks.app/",

  // Social Media Links
  social: {
    facebook: "https://www.facebook.com/DentistinPerrysburg",
    instagram: "https://www.instagram.com/dentistinPerrysburg/",
    twitter: "https://x.com/Dentist_Pburg",
    linkedin: "https://www.linkedin.com/company/dentist-in-perrysburg/",
    youtube: "https://www.youtube.com/@dentistinperrysburg",
  },

  // Review Links (for Patient Reviews page)
  reviewLinks: {
    google: "https://business.google.com/n/8520065851214304866/profile?hl=en-GB&fid=6669893925971637307",
    facebook: "https://www.facebook.com/DentistinPerrysburg",
    yelp: "https://www.yelp.com/biz/dentist-in-perrysburg-perrysburg",
  },

  // Open Dental Configuration
  defaultProvNum: 3,
  defaultOpNum: 14,

  // Appointment Types Configuration
  appointmentTypes: [
    {
      value: "New patient emergency/other",
      label: "New patient emergency/other",
      duration: 30,
      opNum: 13,
      AppointmentTypeNum: 12,
    },
    {
      value: "Existing patient emergency/other",
      label: "Existing patient emergency/other",
      duration: 30,
      opNum: 14, // DEFAULT_OP_NUM
      AppointmentTypeNum: 4,
    },
    {
      value: "Existing patient current treatment Plan",
      label: "Existing patient current treatment Plan",
      duration: 30,
      opNum: 14, // DEFAULT_OP_NUM
      AppointmentTypeNum: 1,
    },
  ],


  // Twilio Configuration
  twilioPhoneNumber: "14198633107",

  // Helper functions for common patterns
  getTelLink: function () {
    return `tel:${this.phoneNumberRaw}`;
  },

  getSmsLink: function (body?: string) {
    const bodyText = body || "Hello%20";
    return `sms:+${this.twilioPhoneNumber}?body=${bodyText}`;
  },

  getEmailLink: function (subject?: string, body?: string) {
    const params = [];
    if (subject) params.push(`subject=${encodeURIComponent(subject)}`);
    if (body) params.push(`body=${encodeURIComponent(body)}`);
    const queryString = params.length > 0 ? `?${params.join('&')}` : '';
    return `mailto:${this.email}${queryString}`;
  },
};

// Export individual items for convenience
export const {
  clinicName,
  clinicId,
  phoneNumber,
  phoneNumberRaw,
  email,
  address,
  addressShort,
  city,
  state,
  stateShortForm,
  mapUrl,
  iframe,
  iframeTitle,
  clarityProjectId,
  membership,
  apiBaseUrl,
  callbackUrl,
  clinicHoursUrl,
  websocketUrl,
  social,
  reviewLinks,
  defaultProvNum,
  defaultOpNum,
  appointmentTypes,
} = CLINIC_CONFIG;

export default CLINIC_CONFIG;
